import { slFooterHtml } from "./slFooter.js";

// React rendering of the shared ServiceLad footer (see slFooter.js).
const FOOTER_HTML = slFooterHtml();

export default function SlCloudFooter() {
  return <div style={{ display: "contents" }} dangerouslySetInnerHTML={{ __html: FOOTER_HTML }} />;
}
